export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wenn Sie dies sehen, wurde das Formular nicht empfangen (aber Sie sollten dies nicht sehen)"])}
}